/**
 * @generated SignedSource<<6e8f234b46f3e65590ccd7622b22756a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FacilityLogoSideNavFragment_club$data = {
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly " $fragmentType": "FacilityLogoSideNavFragment_club";
};
export type FacilityLogoSideNavFragment_club$key = {
  readonly " $data"?: FacilityLogoSideNavFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoSideNavFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FacilityLogoSideNavFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "d3aeeca05e869d20e26a8739ec202dd1";

export default node;
